/***
**Module Name: client
 **File Name :  client.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains clients table details.
 ***/
import React, { useState, useEffect, useContext } from "react";


import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
import Sidebar from "../../../components/dashboard/sidebar";
import tmdbApi from "../../../api/tmdbApi";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import SessionPopup from "../../SessionPopup"
import Loader from "../../../components/loader";


import TableLoader from "../../../components/tableLoader";
import { contentContext } from "../../../context/contentContext";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import Tooltip from '@mui/material/Tooltip'
let { lambda, appname } = window.app;


const ClientEnquiry = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    // const [toggle, setToggle] = useState(false);
    const [deals, setDeals] = useState("");
    const [perpage, setPerpage] = useState(10);
    const [success, setSuccess] = useState(false);
    const [image, setImg] = useState('');

    const [rangeError, setRangeError] = useState("");
    const [loaderEnable, setLoaderEnable] = useState(false);
    // const [data, setData] = useState([]);

    //const [currentPage, setcurrentPage] = useState(1);

    const [dealsmsg, setDealsMsg] = useState("");

    // const [isLoading, setIsLoading] = useState(false);
    const [flag, setFlag] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);


    // const [paginationnumber, setPagintionNumber] = useState({});

    const [popup, setShowPopup] = useState(false);

    const handleClosePopup = () => setShowPopup(false);
    const [sortDirection, setSortDirection] = useState('asc');
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    const [tableErrMsg, setTableErrMsg] = useState(false);
     const [data, setData] = useState([]);
 
    const { searchedFlag, setSearchedFlag, isLoading, setNavigateToggle, fromdate, setFromDate, todate, setToDate, setActiveMenuObj, setIsLoading, processObject, sortTableAlpha, arrow, sortTableByDate, userData, dealsearch, setDealSearch, dealsadvSearch, setDealsAdvSearch, currentPage, setcurrentPage, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)



    // var exportExcelData = ["kiran"]

    const prevRoute = usePrevious(route)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Contact Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].submenus && validateObj[0].submenus[0].dashboard
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setDealsAdvSearch({})
            setSearchedFlag(false);
            setDealSearch("")

        }
        console.log("prevRoute", prevRoute, route);

    }, [prevRoute]);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imagesCDN) {
                    setImg(window.site.common.imagesCDN)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imagesCDN) {
            setImg(window.site.common.imagesCDN)
        }

    }, [window.site]);
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)

    const columns = [

        {
            name: 'Name',
            selector: row => row?.clientname ?? "",
            sortable: true,
        },

        {
            name: 'Type',
            cell: (props) => <button type="button" className="btn btn-primary btn-sm btn-rounded " data-bs-toggle="modal" data-bs-target=".orderdetailsModal">
                {props.clienttype === "BUYER" ? <span className="material-icons-outlined text-primary"> local_mall</span> : props.clienttype === "SELLER" ? <span className="material-icons-outlined text-danger"> storefront</span> : <span className="material-icons-outlined text-success"> group </span>}
                {props.clienttype}
            </button>,
            sortable: false,
        },
        {
            name: 'Account manager',
            selector: row => row?.accountmanager ?? "",
            sortable: true,
        },
        {
            name: 'Enquired On',
            // selector: row => moment(row.created).utc().format("DD-MMM-YYYY HH:mm"),
            selector: row => row.created,
            cell: (props) => props.created != undefined ? new Date(props.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }) : '',
            sortable: true,
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },

        {
            name: 'Followed On',
            // selector: row => moment(row.updated).utc().format("DD-MMM-YYYY HH:mm"),
            selector: row => row.updated,
            cell: (props) => props.updated != undefined ? new Date(props.updated).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
            }) : '',
            sortable: true,
            // sortFunction: (a, b) => moment(a.updated).diff(b.updated),
        },
         {
            name: 'No of Enquired Titles',
            // selector: row => row?.comments ?? '',
             selector: row => row?.clientEnquiryCount ?? "",
            sortable: true,
        },
        {
            name: 'Comments',
            // selector: row => row?.comments ?? '',
            cell: (props) => <Tooltip title={props?.comments} placement="top"><div className="text-elipsis">{props?.comments ?? ""}</div></Tooltip>,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },


        {
            name: <>{(subValDashboard && subValDashboard.view && subValDashboard.view.display === true) || (subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true) ? 'Actions' : null}</>,
            cell: (props) =>
                //   {
                subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&

                <div className="d-flex">
                    {subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
                        <a onClick={e => handleViewDeal(e, props.enquiryid)} className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}><i className="mdi mdi-eye font-size-18"></i></a>}

                </div>

            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };




    const handleShowPopup = () => {
        GetTimeActivity()
        setShowPopup(true);
    };

    const handleExport = (data1) => {
        // let k = defaultData || exportExcelData
        // let k = exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "NAME": each?.clientname ?? "",
            "TYPE": each?.clienttype ?? "",
            "ACCOUNT MANAGER": each?.accountmanager ?? "",
            "ENQUIRED ON": each?.created ? new Date(each?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            }) : "",

            "FOLLOWED ON": each?.updated ? new Date(each?.updated).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',

            }) : "",
            "COMMENTS": each?.comments ?? "",
            "STATUS": each?.status ?? "",



            // "STATUS": status,
        }));
        // console.log('data after',data)

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `DealsData.xlsx`);
    }
    // console.log('exportExcelData',global.exportExcelData)
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            const aField = String(selector(rowA)).toLowerCase();
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(300063)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": true
        })
        setRoute("deal")
        setNavigateToggle("")
        // console.log("trueeeeeeeeee",searchedFlag);
        // if (searchedFlag) { 
        //     console.log("came") 
        //     handleSearch();
        // } else {
        //     console.log("called get all deals") 
        //     getAllDeals();
        // }
        userActivity();

    }, []);
    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }
    useEffect(() => {


        console.log("trueeeeeeeeee", searchedFlag);
        if (searchedFlag) {
            console.log("came")
            handleSearch();
        } else {
            console.log("called get all deals")
            getAllDeals();
        }

    }, [searchedFlag]);


    const getAllDeals = async () => {
        GetTimeActivity()
        setIsLoading(true)
        const token = localStorage.getItem("token")


        const linkUrl = `${lambda}/clientenquiry?appname=${appname}&userid=${localStorage.getItem("userId")}&token=${token}`;

        axios({
            method: 'POST',
            url: linkUrl,
        })
            .then(function (response) {
                // console.log("resssss", response)
                if (response?.data?.result == "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    setData(response?.data?.result?.data);
                    // setTimeout(function () { global.exportExcelData = response?.data?.result?.data }, 1000);

                    global.exportExcelData = response?.data?.result?.data

                    // console.log('exportExcelData--->',global.exportExcelData)

                    setDeals(response?.data?.result);
                    setIsLoading(false);
                    setDealSearch("");
                    setSearchedFlag(false);
                }
            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });

    };






    const handleEditDeal = (e, id) => {
        GetTimeActivity()
        navigate("/editdeals/" + id);
    }

    const handleViewDeal = (e, id) => {
        GetTimeActivity()
        navigate("/viewclientenquiry/" + id);
    }

    const handleSearch = (e, flagggg) => {
        GetTimeActivity()

        setLoaderEnable(true)

        // if (flagggg) {
        //     setCurrentPage(1);
        // }
        if (flagggg === "normalsearch" || flagggg === "click") {
            setSearchedFlag(true)
        }

        setFlag(true)
        if (dealsearch === "" && dealsadvSearch.length <= 0) {
            getAllDeals();
        }
        else {
            if (flagggg === "normalsearch") {
                setIsLoading(true)
            }
            const token = localStorage.getItem("token")
            let urlLink;

            urlLink = lambda + '/clientenquiry?appname=' + appname + "&userid=" + localStorage.getItem("userId") + (dealsearch ? `&search=${dealsearch}` : '') + (fromdate ? `&searchedFrom=${fromdate}` : "") +
                (todate ? `&searchedTo=${todate}` : "") + "&token=" + token

            const result = processObject(dealsadvSearch);
            setDealsAdvSearch(result)
            axios({
                method: 'POST',
                url: urlLink,
                data: result,
            })
                .then(function (response) {
                    if (response?.data?.result == "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                        setShowPopup(false)
                        setLoaderEnable(false)
                    } else {
                        // console.log("response", response);
                        setDeals(response?.data?.result);
                        setData(response?.data?.result?.data);
                        // setTimeout(function () { global.exportExcelData = response?.data?.result?.data }, 1000);
                        global.exportExcelData = response?.data?.result?.data



                        setIsLoading(false)
                        setShowPopup(false)
                        setLoaderEnable(false);
                        if (flagggg === "click") {
                            setDealSearch("")
                        }
                    }
                }).catch((err) => {
                    console.log('error', err);
                    setTableErrMsg(true)
                    setIsLoading(false);
                });
        }
    }

    const handleChange = (e) => {
        // console.log(e.target.value)
        if (e.target.value === "") {
            // getAllDeals();
            setFlag(false)
        }
        setDealSearch(e.target.value)
    }

    function onConfirm() {
        GetTimeActivity()
        setSuccess(false);
        setDealSearch("")
    };
    const handleAddDeal = (e) => {
        setNavigateToggle("alldeals");
        GetTimeActivity()
        navigate("/createdeal")
    }
    const clearSearch = () => {
        GetTimeActivity()
        setDealSearch("");
        getAllDeals();
        setDealsAdvSearch({})
        setcurrentPage(1);
        setSearchedFlag(false)
        localStorage.removeItem("deals")
    }
    const clearAdvSearch = () => {
        GetTimeActivity()
        setDealsAdvSearch({ ...dealsadvSearch, clientname: "", clienttype: "", created: "", updated: "", status: "", comments: "" })
    }

    const handleKeypress = (e) => {
        GetTimeActivity()
        //it triggers by pressing the enter key

        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 100);
        }
    };

    const handleAdvChange = (e) => {
        GetTimeActivity()
        setDealsAdvSearch({ ...dealsadvSearch, [e.target.name]: e.target.value });
    }
    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No deals were found for the searched keyword</p>
                </div> </div>
        )
    }

    const customNoRecordsMessage = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No deals were found for the searched keyword</p>
                </div> </div>
        )
    }
    // console.log('vdata?.[0]?.message',data?.[0]?.message)
    //     console.log("deals", data)
    const getFormattedDate = (date) => {
        // Convert to local time and format the date as YYYY-MM-DD
        return moment(date).local().format('YYYY-MM-DD');
    };
    const currentDate = new Date();
    let sixMonthsAgo = new Date(currentDate.getFullYear(), currentDate.getMonth() - 6, currentDate.getDate());
    const difference = currentDate.getTime() - sixMonthsAgo.getTime();
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 1);

    const formattedFromDate = getFormattedDate(threeMonthsAgo);
    const formattedToDate = getFormattedDate(new Date());
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                <div className="main-content user-management clients deals deals-wrapper">

                    <div className="page-content">
                        <div className="container-fluid table-data">

                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">Client Enquiry Report</h4>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row mb-2">

                                                <div className="col-sm-4 button-block">
                                                    <div className="dataTables_length" id="datatable_length">
                                                        <button className={`fill_btn ${data.length <= 0 || data?.[0]?.message === "ContentEnquiry Data not available" ? 'disable pe-none' : ''}`} onClick={(e) => handleExport(data)}><span className="material-icons">north_east</span>Export</button>
                                                    </div>

                                                </div>
                                                <div className="col-sm-8">

                                                    <div className="search-box mb-2 d-inline-block">
                                                        {/* <div className="position-relative">
                                                                                                             <input type="text" className="form-control" placeholder="Search by client name" value={ClientNameSearch} onChange={(e) => handleChange(e)} onKeyPress={handleKeypress} />
                                                                                                             <button className="fill_btn" onClick={getClientActivity}><span className="material-icons search-icon">search</span></button>
                                                                                                         </div> */}
                                                        <div className="position-relative">
                                                            <input type="text" className="form-control" placeholder="Search by client name" value={dealsearch} onChange={(e) => handleChange(e)} onKeyPress={handleKeypress} />

                                                            <div className="input-daterange input-group" id="datepicker6" data-date-format="dd M, yyyy" data-date-autoclose="true" data-provide="datepicker" data-date-container='#datepicker6'>

                                                                <Tooltip title="From Date" placement="top">
                                                                    <input type="date" className="form-control date-input" name="availableFrom" placeholder="Start Date" value={fromdate} onChange={(e) => { setFromDate(e.target.value); setRangeError(false) }} max={new Date().toISOString().split('T')[0]} />
                                                                </Tooltip>


                                                                <Tooltip title="To Date" placement="top">
                                                                    <input type="date" className="form-control date-input" name="availableTo" placeholder="End Date" value={todate} onChange={(e) => { setToDate(e.target.value); setRangeError(false) }} max={new Date().toISOString().split('T')[0]} />
                                                                </Tooltip>

                                                            </div>
                                                            <button className="fill_btn" onClick={(e) => handleSearch(e, "normalsearch")}><span className="material-icons search-icon">search</span></button>



                                                        </div>
                                                        <div className="dataTables_length" id="datatable_length">
                                                            <button className="fill_btn" onClick={clearSearch}><span className="material-icons-outlined">sync</span>Reset</button>
                                                        </div>


                                                    </div>
                                                    <div className="text-sm-end">
                                                        {rangeError != "" ? <span className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{rangeError}</span> : null}
                                                    </div>
                                                </div>
                                            </div>

                                            {data?.[0]?.message === "ContentEnquiry Data not available" ? customNoRecordsMessage() :
                                                < DataTable key={keyForRerender}

                                                    // title=""
                                                    columns={columns}
                                                    // className="table align-middle table-nowrap table-check"
                                                    keyField='_id'
                                                    data={data}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    responsive
                                                    persistTableHead
                                                    // selectableRowsVisibleOnly
                                                    striped
                                                    // selectableRowsHighlight
                                                    // selectableRows
                                                    subHeaderAlign="right"
                                                    defaultSortField="name"
                                                    subHeaderWra
                                                    noDataComponent={customNoRecords()}
                                                    paginationTotalRows={data && data.length}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    paginationPerPage={rowsPerPage}
                                                    paginationDefaultPage={currentPageNew}
                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                    sortFunction={customSort}

                                                    paginationComponentOptions={{
                                                        rowsPerPageText: 'Per page:',
                                                        rangeSeparatorText: 'of',
                                                        noRowsPerPage: false,
                                                        selectAllRowsItem: false,
                                                        selectAllRowsItemText: 'All',
                                                    }}

                                                    progressPending={isLoading}
                                                    progressComponent={<TableLoader />}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"No Results Found"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>
                    <SweetAlert show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                    >
                    </SweetAlert>
                    <Modal className="advance-search search-popup" show={popup} onHide={handleClosePopup} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>Advanced Search</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">NAME</label>
                                            <input className="form-control" placeholder="Enter Name" type="text" name="clientname"
                                                value={dealsadvSearch.clientname} onChange={(e) => handleAdvChange(e)}
                                                id="example-text-input" />

                                        </div>
                                    </div>



                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Type</label>

                                            <select className="form-select" name="clienttype"
                                                value={dealsadvSearch.clienttype} onChange={(e) => handleAdvChange(e)}
                                            >
                                                <option value="">Select Type</option>
                                                <option>BUYER</option>
                                                <option>SELLER</option>
                                                <option>BOTH</option>
                                            </select>

                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">ENQUIRED ON</label>
                                            <input id="rights1" name="created" placeholder="dd-mm-yyyy" type="date" className="form-control"
                                                value={dealsadvSearch.created} onChange={(e) => handleAdvChange(e)} max={new Date().toISOString().split('T')[0]}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">FOLLOWED ON</label>
                                            <input id="rights1" name="updated" placeholder="dd-mm-yyyy" type="date" className="form-control"
                                                value={dealsadvSearch.updated} onChange={(e) => handleAdvChange(e)} max={new Date().toISOString().split('T')[0]}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">comments</label>
                                            <input className="form-control" placeholder="Enter Comments" type="text" name="comments"
                                                value={dealsadvSearch.comments} onChange={(e) => handleAdvChange(e)}
                                                id="example-text-input" />

                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="input-field">
                                            <label className="col-form-label">Status</label>

                                            <select className="form-select" name="status"
                                                value={dealsadvSearch.status} onChange={(e) => handleAdvChange(e)}
                                            >
                                                <option value="">Select Status</option>
                                                <option value="NEW">NEW</option>
                                                <option value="INPROGRESS">INPROGRESS</option>
                                                <option value="PARTIALLY CLOSED">PARTIALLY CLOSED</option>
                                                <option value="CLOSED">CLOSED</option>
                                                <option value="SUCCESSFULLY CLOSED">SUCCESSFULLY CLOSED</option>
                                            </select>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>

                            <div className="adv_footer">
                                <button className="fill_btn yellow-gradient reset-btn" onClick={clearAdvSearch}><span className="material-icons-outlined">sync</span>Reset</button>

                                <button
                                    onClick={(e) => handleSearch(e, "click")}
                                // className={`fill_btn yellow-gradient float-end ${Object.keys(searchPayload).length == 0 ? "disable" : ""}`} disabled={Object.keys(searchPayload).length == 0} 
                                >
                                    {loaderEnable ? (<img src={image + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} className="loading-icon" />) : null}  SEARCH
                                </button>

                                <div className="clearfix"></div>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Footer />
                </div>

            </div>
        </>
    );
};

export default ClientEnquiry;
